import { z } from 'zod';
export const InitialClaimActionsSchema = z.enum([
    'requiresEmergencyBoardUp',
    'requiresFireOrSmokeMitigation',
    'requiresGeneralContractor',
    'requiresRoofTarping',
    'requiresTreeRemoval',
    'requiresWaterExtraction',
]);
